var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscribe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.44105 8.50001L7.94105 10L10.941 7.00001M5.5673 3.02276C6.10528 2.97982 6.61601 2.76829 7.0268 2.41826C7.49098 2.02246 8.08103 1.80505 8.69105 1.80505C9.30107 1.80505 9.89112 2.02246 10.3553 2.41826C10.7661 2.76829 11.2768 2.97982 11.8148 3.02276C12.4228 3.07114 12.9937 3.33463 13.4251 3.76595C13.8564 4.19728 14.1199 4.7682 14.1683 5.37626C14.2112 5.91424 14.4227 6.42497 14.7728 6.83576C15.1686 7.29994 15.386 7.88999 15.386 8.50001C15.386 9.11003 15.1686 9.70008 14.7728 10.1643C14.4227 10.5751 14.2112 11.0858 14.1683 11.6238C14.1199 12.2318 13.8564 12.8027 13.4251 13.2341C12.9937 13.6654 12.4228 13.9289 11.8148 13.9773C11.2768 14.0202 10.7661 14.2317 10.3553 14.5818C9.89112 14.9776 9.30107 15.195 8.69105 15.195C8.08103 15.195 7.49098 14.9776 7.0268 14.5818C6.61601 14.2317 6.10528 14.0202 5.5673 13.9773C4.95924 13.9289 4.38832 13.6654 3.95699 13.2341C3.52567 12.8027 3.26218 12.2318 3.2138 11.6238C3.17086 11.0858 2.95933 10.5751 2.6093 10.1643C2.2135 9.70008 1.99609 9.11003 1.99609 8.50001C1.99609 7.88999 2.2135 7.29994 2.6093 6.83576C2.95933 6.42497 3.17086 5.91424 3.2138 5.37626C3.26218 4.7682 3.52567 4.19728 3.95699 3.76595C4.38832 3.33463 4.95924 3.07114 5.5673 3.02276Z",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.691406 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribe);
export default __webpack_public_path__ + "static/media/subscribe.06c82ca78ce1bedd739a08dd8166a5fa.svg";
export { ForwardRef as ReactComponent };